/**
 * Created with IntelliJ IDEA.
 * User: noam
 * Date: 1/14/14
 * Time: 5:33 PM
 * To change this template use File | Settings | File Templates.
 */
define(function (require) {
    "use strict";

    var LE = require("app");
    var template = require("content-templates/content-edit/canned/editorCannedWrapper.tmpl");
    var InputField = require("ui/input-field/InputField");
    var TextareaField = require("ui/textarea-field/TextareaField");
    var Button = require("ui/button/Button");
    var DropdownMenu = require('ui/dropdown-menu/DropdownMenu');
    var ValidationUtilities = require("utils/ValidationUtilities");
    var cannedMessageConfig = require("content-config/cannedMessageConfig.json");

    //todo add real wysywig editor

    var EditorCannedWrapperView = {};
    LE.module("LEContent", function (LEContent, LE, Backbone, Marionette, $, _) {

        EditorCannedWrapperView = Marionette.ItemView.extend({
            template: template,
            ui: {
                titleLabel:        ".title-field-label",
                titleContainer:    ".title-container",
                editorContainer:   ".editor-container",
                selectAddMacroDropdownContainer: ".add-macro-dropdown-container"
            },
            uiComponents: {
                titleField: {
                    type: InputField,
                    options:{         // Component initialization options
                        permutation:InputField.Permutation.P,
                        el:"view.ui.titleContainer",            // Using the ui definitions on the view requires the "view." prefix
                        maxLength: cannedMessageConfig.maxTitleSize,
                        value: ""
                    },
                    events:{                                        // Events that should be dispatched and propagated from the component to the parent view
                        change:"_titleChange"
                    }
                },
                editorField: {
                    type: TextareaField,
                    options:{         // Component initialization options
                        permutation:TextareaField.PERMUTATION.F,
                        el:"view.ui.editorContainer",            // Using the ui definitions on the view requires the "view." prefix
                        value: "" ,
                        maxChars: cannedMessageConfig.maxMessageSize
                    },
                    events:{                                        // Events that should be dispatched and propagated from the component to the parent view
                        change:"_editorTextChange"
                    }
                },
                addMacroDropdown: {
                    type:DropdownMenu,
                    options:{
                        name:LE.translator.translate("LEContent.content.macros.placeholder"),
                        el:"view.ui.selectAddMacroDropdownContainer",
                        collection: new DropdownMenu.Collection([])
                    },
                    events:{
                        "change":"_onMacroSelection"
                    }
                }
            },
            validationSettings: {
                titleField: {
                    uiKey: "titleField",
                    errKeys: [""],
                    uiType: "uiComponents"
                },
                editorField: {
                    uiKey: "editorField",
                    errKeys: [""],
                    uiType: "uiComponents"
                }
            },

            initialize: function (options) {
                LEContent.logger.debug("Initializing EditorCannedWrapperView","EditorCannedWrapperView:initialize") ;
                this.channel = options.channel;
                this.contentModel = options.model.getContentModel();

                this.listenTo(this.model.getLanguageTabCollection(),"change:selection",this._updateViewWithSelectedLanguageContent);
                this.listenTo(this.model,"change:model",this._updateViewWithChangedModel);
            },
            onRender: function () {
                LEContent.logger.debug("onRender EditorCannedWrapperView","EditorCannedWrapperView:onRender") ;
                 this._updateViewWithChangedModel();
            },
            _setValidationSettings : function() {
                if (this.model.hasTitleField()){
                    this.validationSettings.titleField.errKeys = [this.model.getContentTitleKey()];
                } else{
                    this.validationSettings.titleField.errKeys = [];
                }

                this.validationSettings.editorField.errKeys = [this.model.getContentMSGKey()];
            },
            _updateViewWithSelectedLanguageContent: function(){
                if (this.editorsLanguage !== this.model.getSelectedLanguage()) { //do not clear errors when its the same language content already seen
                    this.editorsLanguage = this.model.getSelectedLanguage();
                    this._clearErrors();
                }

                this._setValidationSettings();
                this.uiComponents.titleField.setValue(this.model.getSelectedLanguageContentTitle());

                if (this._newLine2Br(this.uiComponents.editorField.getValue()) !== this.model.getSelectedLanguageContentMessage()) {
                    this.uiComponents.editorField.setValue(this._br2newLine(this.model.getSelectedLanguageContentMessage()));
                }
            },
            _updateViewWithChangedModel: function () {
                this.stopListening(this.contentModel);
                this.contentModel = this.model.getContentModel();
                this.listenTo(this.contentModel,"invalid",this._invalid);
                this.listenTo(this.contentModel,"change:data",this._updateViewWithSelectedLanguageContent);
                this._clearErrors();
                this._updateViewWithSelectedLanguageContent();
                this._updateMacroDropdownOptions();
            },
            _updateMacroDropdownOptions: function(){
                var allowedMacros = this.model.getAllowedMacros();

                if(allowedMacros.length === 0){
                    this.uiComponents.addMacroDropdown.setEnabled(false);
                    this.ui.selectAddMacroDropdownContainer.addClass("hide");
                }
                else{
                    var items = _.map(allowedMacros,function(macro){
                        return {
                            id: macro.value,
                            "actionName": LE.translator.translate("LEContent.content.macros." + macro.id),
                            "enabled": true,
                            "title": LE.translator.translate("LEContent.content.macros." + macro.id +".tooltip")
                        };
                    },this);

                    this.uiComponents.addMacroDropdown.setEnabled(true);
                    this.ui.selectAddMacroDropdownContainer.removeClass("hide");
                    this.uiComponents.addMacroDropdown.setItems(new DropdownMenu.Collection(items));
                }
            },
            _onMacroSelection: function (componentId, eventName, id){
                this.uiComponents.editorField.setValueAtCourser(this._br2newLine(id));
            },
            _titleChange: function (componentId, eventName, value) {
                this.channel.trigger("editorCannedWrapperView:title:change",value.trim());
            },

            _editorTextChange: function (componentId, eventName, value) {
                var brredText = this._newLine2Br(value.trim());
                this.channel.trigger("editorCannedWrapperView:editor:text:change",brredText);
            },
            _newLine2Br: function (text){
                return text.replace(/\r\n|\r|\n/g,"<br/>");
            },
            _br2newLine: function (text){
                return text.replace(/<br\/>/g,"\r\n");
            },
            _invalid: function(model, errors) {
                LEContent.logger.info("on Invalid called", "EditCannedTextView:onInvalid");
                ValidationUtilities.setValidationErrors(this,false,this.contentModel);
            },
            _clearErrors: function(){
                this.uiComponents.titleField.setError(false);
                this.uiComponents.editorField.setError(false);
            },

            onClose: function () {
                LEContent.logger.debug("onClose EditorCannedWrapperView", "EditorCannedWrapperView:onClose");
            }
        });

    });
    return EditorCannedWrapperView;
});
